export enum MessageBoxImageType {
  None = 0,
  Error = 1,
  Question = 2,
  Warning = 3,
  Information = 4,
}
